import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-inbox }}\n{{yield this.timestamp}}",{ moduleName: "embercom/components/inbox2/common/updating-timestamp.hbs" })